import useSWR from 'swr'

import { CountryCode } from '../types'
import createRestClient from './createRestClient'
import useWorkspaceId from './useWorkspaceId'

export default function useCountryCodeFromIPAddress() {
  const workspaceId = useWorkspaceId()
  const { data, error } = useSWR('location', async () => {
    const { countryCode } = await createRestClient(workspaceId).get<{
      countryCode: CountryCode | null
    }>('location')

    return countryCode
  })

  if (error) {
    return 'US'
  }

  return data
}
